import { toApiError } from "@services/api";
const BASE_URL = process.env.REACT_APP_API_URL ?? window.location.origin;

export type WeightChartMarkerKind = "point" | "interval";

export type WeightChartMarker = {
  id: string;
  userId: string;
  deviceEsn: string;
  label: string;
  kind: WeightChartMarkerKind;
  start: string;
  stop: string;
  createdAt: string;
  updatedAt: string;
};

export async function fetchWeightChartMarkers(
  deviceEsn: string
): Promise<WeightChartMarker[]> {
  const params = new URLSearchParams({ deviceEsn });
  const url = `${BASE_URL}/api/v1/weight-chart-markers?${params}`;
  const response = await fetch(url);
  if (!response.ok) {
    throw await toApiError(response, "Failed to fetch markers");
  }
  const body = await response.json();
  return body.markers ?? [];
}

export async function createWeightChartMarker(data: {
  deviceEsn: string;
  label: string;
  kind: WeightChartMarkerKind;
  start: string;
  stop: string;
}): Promise<WeightChartMarker> {
  const url = `${BASE_URL}/api/v1/weight-chart-markers`;
  const response = await fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  if (!response.ok) {
    throw await toApiError(response, "Failed to create marker");
  }
  return response.json();
}

export async function updateWeightChartMarkerLabel(
  id: string,
  label: string
): Promise<WeightChartMarker> {
  const url = `${BASE_URL}/api/v1/weight-chart-markers/${id}`;
  const response = await fetch(url, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ label }),
  });
  if (!response.ok) {
    throw await toApiError(response, "Failed to update marker");
  }
  return response.json();
}

export async function deleteWeightChartMarker(id: string): Promise<void> {
  const url = `${BASE_URL}/api/v1/weight-chart-markers/${id}`;
  const response = await fetch(url, { method: "DELETE" });
  if (!response.ok) {
    throw await toApiError(response, "Failed to delete marker");
  }
}
